import { CurrentAccountRouting } from './CurrentAccountRouting';

export const CurrentAccountModule = () => {
  return <CurrentAccountRouting />;
};
